// src/utils/global.js

/**
 * Convert minutes to HH:MM:SS format
 *
 * @param {number|null|undefined} minutes
 * @returns {string}
 */
export const minutesToHHMMSS = (minutes) => {
  if (minutes === null || minutes === undefined || isNaN(minutes)) {
    return 'SLA Not Assigned';
  }
  else if (minutes === 0) {
    return '00:00:00';
  }
  else{
    const totalSeconds = Math.floor(minutes * 60);

    const hours = Math.floor(totalSeconds / 3600);
    const remainingSeconds = totalSeconds % 3600;
    const mins = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds % 60;
  
    const pad = (value) => String(value).padStart(2, '0');
  
    return `${pad(hours)}:${pad(mins)}:${pad(seconds)}`;
  }


};

export const formatTimeFromMinutes = (minutes) => {
  if (minutes === null || minutes === undefined) return 'N/A';
  const absMinutes = Math.abs(minutes);
  if (absMinutes < 60) {
    return minutes < 0 ? `${absMinutes}m overdue` : `${absMinutes}m`;
  } else if (absMinutes < 1440) {
    const hours = Math.floor(absMinutes / 60);
    const mins = absMinutes % 60;
    return minutes < 0 ? `${hours}h ${mins}m overdue` : `${hours}h ${mins}m`;
  } else {
    const days = Math.floor(absMinutes / 1440);
    const hours = Math.floor((absMinutes % 1440) / 60);
    return minutes < 0 ? `${days}d ${hours}h overdue` : `${days}d ${hours}h`;
  }
};

export const getTimeRemaining = (dueDate) => {
  const now = new Date();
  const due = new Date(dueDate);
  const diff = due - now;
  
  if (diff < 0) return 'Overdue';
  
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m`;
};

export const formatTimeWithSeconds = (minutes, seconds) => {
  if (minutes === null || minutes === undefined) return 'N/A';
  if (seconds === null || seconds === undefined) seconds = 0;
  
  const absMinutes = Math.abs(minutes);
  const absSeconds = Math.abs(seconds);
  
  if (absMinutes < 60) {
    return minutes < 0 
      ? `${absMinutes}m ${absSeconds}s overdue` 
      : `${absMinutes}m ${absSeconds}s`;
  } else if (absMinutes < 1440) {
    const hours = Math.floor(absMinutes / 60);
    const mins = absMinutes % 60;
    return minutes < 0 
      ? `${hours}h ${mins}m ${absSeconds}s overdue` 
      : `${hours}h ${mins}m ${absSeconds}s`;
  } else {
    const days = Math.floor(absMinutes / 1440);
    const hours = Math.floor((absMinutes % 1440) / 60);
    const mins = absMinutes % 60;
    return minutes < 0 
      ? `${days}d ${hours}h ${mins}m ${absSeconds}s overdue` 
      : `${days}d ${hours}h ${mins}m ${absSeconds}s`;
  }
};

export const formatDateTime = (isoString) => {
  if (!isoString) return '';

  // Remove microseconds if present
  const safeIso = isoString.includes('.')
    ? isoString.substring(0, isoString.indexOf('.'))
    : isoString;

  const date = new Date(safeIso);

  if (isNaN(date.getTime())) return '-';

  const pad = (num) => String(num).padStart(2, '0');

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();

  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};


export const minutesToHHMMSS2 = (minutes) => {
  const totalSeconds = Math.floor(minutes * 60);

  const hours = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}


